import { Link, useLocation } from 'react-router-dom';

import loguito from '../../static/loguito.svg'

import '../../scss/footer.scss'
// import { linkSync } from 'fs';
// import loguito3 from '../../static/loguito3.svg'

interface IProps {
    moverseA: (id: string) => void
}

const Footer = ({ moverseA }: IProps): JSX.Element => {
    const { pathname } = useLocation();
    return (
        <div className="main_Footer">
            <div className="contentFooter">
                <div className="infoGeneral">
                    <div className="optInformation">
                        <div className='imggoltyty'>
                            <img src={loguito} alt="img Entity" loading="lazy" />
                        </div>
                        <div className="bodyOpt">
                            <p className="infoPltc">
                                Confía en nosotros, somos cuídate. Profesionales en salud sexual y reproductiva.
                            </p>
                            <div className="socialIcons">
                                <div className="contIcon">
                                    <Link to={{ pathname: "https://www.instagram.com/cuidate1020/?hl=es" }} aria-label="instagram" target="_blank" rel="noreferrer">
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div>
                                <div className="contIcon">
                                    <Link to={{ pathname: "https://www.tiktok.com/@cuidate_consultorios?lang=es" }} aria-label="tiktok" target="_blank" rel="noreferrer">
                                        <i className="fab fa-tiktok" />
                                    </Link>
                                </div>
                                <div className="contIcon">
                                    {/* <Link to={{ pathname: "https://www.facebook.com/cuidatecapacitaciones" }} aria-label="facebook" target="_blank" rel="noreferrer">
                                        <i className="fab fa-facebook-f" />
                                    </Link> */}
                                    <Link to={{ pathname: `${pathname.includes('service/assistance') ? 'https://www.facebook.com/Cuidateconsultoriosespecializados' : 'https://www.facebook.com/cuidatecapacitaciones'}` }} aria-label="facebook" target="_blank" rel="noreferrer">
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="optInformation">
                        <div className="titteOpt">
                            Empresa
                        </div>
                        <div className="bodyOpt">
                            <p className="predirc" onClick={() => moverseA('sobreNosotros')}>
                                Sobre nosotros
                            </p>
                            <p className="predirc" onClick={() => moverseA('galeria')}>
                                Galería
                            </p>
                            <p className="predirc" onClick={() => moverseA('nuestroEquipo')}>
                                Nuestro equipo
                            </p>
                            <p className="predirc" onClick={() => moverseA('contactanos')}>
                                Contáctanos
                            </p>
                        </div>
                    </div>
                    <div className="optInformation">
                        <div className="titteOpt">
                            Servicios
                        </div>
                        <div className="bodyOpt">
                            <p>
                                {/* <Link to='/service/academic'> */}
                                <Link to='' onClick={ (e) => e.preventDefault() }>
                                    Académicos
                                </Link>
                            </p>
                            <p>
                                <Link to='/service/assistance'>
                                    Asistenciales
                                </Link>
                            </p>
                        </div>
                    </div>
                    <div className="optInformation">
                        <div className="titteOpt">
                            Encuéntranos
                        </div>
                        <div className="bodyOpt">
                            <p style={{ display: 'grid', gridTemplateColumns: '17px auto', lineHeight: '145%' }}>
                                <span><i className="fas fa-envelope" /></span>
                                central@cuidate.com.pe
                            </p>
                            <p style={{ display: 'grid', gridTemplateColumns: '17px auto', lineHeight: '145%' }}>
                                <span><i className="fas fa-mobile-alt" /></span>
                                +51 968 888 927 (Citas) / 983 589 281 (Capacitación)
                            </p>
                            <p style={{ display: 'grid', gridTemplateColumns: '17px auto', lineHeight: '145%' }}>
                                <span><i className="fas fa-map-marker-alt" /></span>
                                Calle Tomas Ramsey 930. Of. 408. Magdalena del Mar
                            </p>
                            <p style={{ display: 'grid', gridTemplateColumns: '17px auto', lineHeight: '145%' }}>
                                <span><i className="fas fa-map-marker-alt" /></span>
                                Jr. Agustin Gamarra 1020 - 9no piso. Galeria Tomasini. La Victoria
                            </p>
                        </div>
                    </div>
                </div>
                <div className="terpomali">
                    <span>
                        <Link to="/terms">Términos y condiciones</Link>
                    </span>|
                    <span> Políticas de privacidad </span>|
                    <span> Mapa del sitio </span>|
                    <span> Libro de reclamaciones</span>
                </div>
                <div className="btnwhsta">
                    <Link to={{ pathname: `${pathname.includes('service/assistance') ? 'https://api.whatsapp.com/send?phone=51968888927&text=INFORMES+Y+CITAS+EN+CUIDATE+PARA+ATENCI%C3%93N' : 'https://bit.ly/InformesCapacitacionesCuídate'}` }} target="_blank" rel="noreferrer">
                        <i className="fab fa-whatsapp" />
                    </Link>
                </div>
            </div >
        </div >
    )
}

export default Footer
